(()=>{
  'use strict';
  if(window.GGPixCheckoutData)return;
  const key='_ggpix_checkout',pattern=String.raw`^GGPIX1\|[A-Za-z0-9_-]{5,100}\|[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z\|https://(?:cdn\.shopify\.com|cdn\.shopify\.com-uploadkit\.app|files\.getuploadkit\.com|ggpix\.ro)/[^|\s]+\|(?:manifest:https://(?:files\.getuploadkit\.com|cdn\.shopify\.com|ggpix\.ro)/[^|\s]+|zip:https://(?:cdn\.shopify\.com|ggpix\.ro)/[^|\s]+|secure:[a-f0-9-]{36})$`,valid=new RegExp(pattern);
  const releaseKey='_ggpix_release',release='final-200744141177';
  let queue=Promise.resolve();
  const route=()=>window.Shopify?.routes?.root||'/';
  function link(value){try{const u=new URL(value);return u.protocol==='https:'&&!u.username&&!u.password?u.href:'';}catch{return '';}}
  function payload(properties={}){
    const id=properties._ggpix_design_id,at=properties._ggpix_approved_at,preview=link(properties['Previzualizare GG Pix']||properties['Élő előnézet']);
    let print='';
    if(properties['_GGPix producție manifest'])print='manifest:'+link(properties['_GGPix producție manifest']);
    else if(properties['_GGPix producție ZIP'])print='zip:'+link(properties['_GGPix producție ZIP']);
    else if(properties._ggpix_secure_project)print='secure:'+properties._ggpix_secure_project;
    const value=['GGPIX1',id,at,preview,print].join('|');
    return value.length<=4000&&valid.test(value)?value:'';
  }
  async function request(path,options={}){
    const response=await fetch(route()+path,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(20000),...options});
    if(!response.ok)throw Error('checkout_data_failed');
    return response.json();
  }
  async function update(item,{sections=[],sectionsUrl=location.pathname}={}){
    if(!item?.properties?._ggpix_design_id)return item;
    const cart=await markRelease(await request('cart.js')),matches=cart.items.filter(row=>row.properties?._ggpix_design_id===item.properties._ggpix_design_id);
    if(matches.length!==1)throw Error('checkout_data_ambiguous');
    const row=matches[0],value=payload(row.properties);
    if(!value)throw Error('checkout_data_incomplete');
    if(row.properties[key]===value)return {...row,sections:item.sections};
    const body={id:row.key,quantity:row.quantity,properties:{...row.properties,[key]:value}};
    if(sections.length){body.sections=sections.slice(0,5);body.sections_url=sectionsUrl;}
    const result=await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const updated=result.items?.find(candidate=>candidate.properties?._ggpix_design_id===row.properties._ggpix_design_id&&candidate.properties?.[key]===value);
    if(!updated||updated.quantity!==row.quantity)throw Error('checkout_data_incomplete');
    return {...updated,sections:result.sections||item.sections};
  }
  function sealItem(item,options){const operation=queue.then(()=>update(item,options));queue=operation.catch(()=>{});return operation;}
  async function markRelease(cart){
    if(cart.attributes?.[releaseKey]===release)return cart;
    const marked=await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[releaseKey]:release}})});
    if(marked.attributes?.[releaseKey]!==release)throw Error('checkout_release_failed');
    return marked;
  }
  async function sealCart(){const cart=await markRelease(await request('cart.js'));for(const item of cart.items)if(item.properties?._ggpix_design_id&&payload(item.properties))await sealItem(item);}
  window.GGPixCheckoutData=Object.freeze({key,pattern,payload,sealItem,sealCart,releaseKey,release});
})();
